var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9L22.6553 14.7737C22.8742 14.9636 23 15.2392 23 15.5291V22C23 22.5514 22.5538 22.9985 22.0028 23H10C9.44771 23 9 22.5523 9 22V15.5291C9 15.2392 9.12576 14.9636 9.3447 14.7737L16 9ZM10 15.7764C10 15.6315 10.0629 15.4937 10.1723 15.3987L16 10.3431L21.8277 15.3987C21.9371 15.4937 22 15.6315 22 15.7764V21.4747C22 21.7509 21.7761 21.9747 21.5 21.9747L18 21.9747L18 20C18 19.4477 17.5523 19 17 19L15 19C14.4477 19 14 19.4477 14 20L14 21.9747L10.5 21.9747C10.2239 21.9747 10 21.7509 10 21.4747V15.7764Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a857ca5148b502a280bfb20f1e3957bd.svg";
export { ForwardRef as ReactComponent };